import api from "./api";

const other = {
    getUser() {
        return api.get(`/user`);
    },
};

export default other;
